import { BaseComponent } from './base.component';
import { HostListenerModel } from '../../../models/hostlistener';
import { ElementRef, HostListener } from '@angular/core';
import { Helpers } from '../../../helpers';

export abstract class DatatableComponent extends BaseComponent {
    public selectedItemsIds: string[] = [];
    public dtType: string = 'remote';
    public pagesize: number = 20;
    public columns;
    public dtoptions;
    public datatableUrl: string;
    public params: any;
    public id: any;
    public datatable: any;
    public selectorId: any;
    public hostListenerModels: HostListenerModel[] = [];
    public localData = [];

    constructor(protected el: ElementRef) {
        super();
    }

    public setParams(param): DatatableComponent {
        this.params = param;
        return this;
    }

    private buildParams() {
        if (this.params === null) {
            this.params = {
                // custom query params
                query: {
                    query: ''
                }
            };
        }
    }

    abstract updateTrigger();
    abstract deleteTrigger();
    abstract buildDatatableParams();

    private getDataSource(dataType) {
        var source = {};
        if (dataType == 'remote') {
            var apiEndpoint = Helpers.getApiEndpoint();
            var token = Helpers.getAccessToken();
            source = {
                read: {
                    url: apiEndpoint + this.datatableUrl,
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    params: this.params
                }
            };
        } else if (dataType == 'local') {
            source = this.localData;
        }
        return source;
    }

    public buildDatatable() {
        this.buildDatatableParams();
        this.buildParams();

        this.dtoptions = {
            data: {
                type: this.dtType,
                source: this.getDataSource(this.dtType),
                map: function(raw) {
                    // sample data mapping
                    var dataSet = raw;
                    if (typeof raw.data !== 'undefined') {
                        dataSet = raw.data;
                    }
                    return dataSet;
                },
                pageSize: this.pagesize, // display 20 records per page
                serverPaging: false,
                serverFiltering: false,
                serverSorting: false
            },

            // layout definition
            layout: {
                theme: 'default', // datatable theme
                class: '', // custom wrapper class
                height: 'auto', // datatable's body's fixed height
                footer: false // display/hide footer
            },

            // column sorting
            sortable: true,

            // toolbar
            toolbar: {
                // toolbar placement can be at top or bottom or both top and bottom repeated
                placement: ['bottom'],

                // toolbar items
                items: {
                    // pagination
                    pagination: {
                        // page size select
                        pageSizeSelect: [20, 50, 100, 500] // display dropdown to select pagination size. -1 is used for "ALl" option
                    }
                }
            },

            search: {
                // enable trigger search by keyup enter
                onEnter: false,
                // input text for search
                input: $('#generalSearch'),
                // search delay in milliseconds
                delay: 400
            },

            // columns definition
            columns: this.columns
        };
        if (!this.selectorId) this.selectorId = 'datatable';
        var selector = '#' + this.selectorId;
        this.datatable = (<any>$(selector)).mDatatable(this.dtoptions);
    }

    getSelectedRows() {
        var ids = this.datatable
            .rows('.m-datatable__row--active')
            .nodes()
            .find('.m-checkbox--single > [type="checkbox"]')
            .map(function(i, chk) {
                return $(chk).val();
            });
        return ids;
    }

    refreshDatatable() {
        this.datatable.load();
        this.selectedItemsIds = [];
    }

    @HostListener('click', ['$event'])
    onClick() {
        let e = <any>event;
        try {
            if (e.target.offsetParent.classList.contains('update-row')) {
                var id = (<any>event).target.offsetParent.id;
                let element = this.el.nativeElement.querySelector('#' + id);
                if (element) {
                    this.id = element.getAttribute('data-id');
                    this.updateTrigger();
                }
            } else if (e.target.classList.contains('update-row')) {
                var id = (<any>event).target.id;
                let element = this.el.nativeElement.querySelector('#' + id);
                if (element) {
                    this.id = element.getAttribute('data-id');
                    this.updateTrigger();
                }
            } else if (e.target.offsetParent.classList.contains('delete-row')) {
                var id = (<any>event).target.offsetParent.id;
                let element = this.el.nativeElement.querySelector('#' + id);
                if (element.classList.contains('delete-row')) {
                    this.id = element.getAttribute('data-id');
                    this.deleteTrigger();
                }
            } else if (e.target.classList.contains('delete-row')) {
                var id = (<any>event).target.id;
                let element = this.el.nativeElement.querySelector('#' + id);
                if (element.classList.contains('delete-row')) {
                    this.id = element.getAttribute('data-id');
                    this.deleteTrigger();
                }
            }

            this.hostListenerModels.forEach(element => {
                if (e.target.offsetParent.classList.contains(element.selecterClass)) {
                    var id = (<any>event).target.offsetParent.id;
                    let item = this.el.nativeElement.querySelector('#' + id);
                    if (item.classList.contains(element.selecterClass)) {
                        this.id = item.getAttribute('data-id');
                        if (element.invokeMethod) element.invokeMethod();
                    }
                } else if (e.target.classList.contains(element.selecterClass)) {
                    var id = (<any>event).target.id;
                    let item = this.el.nativeElement.querySelector('#' + id);
                    if (item.classList.contains(element.selecterClass)) {
                        this.id = item.getAttribute('data-id');
                        if (element.invokeMethod) element.invokeMethod();
                    }
                }
            });
            var selectedItems = this.getSelectedRows();
            this.selectedItemsIds = [];
            for (var i = 0; i < selectedItems.length; i++) {
                var element = selectedItems[i];
                this.selectedItemsIds.push(element);
            }
        } catch (e) { }
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/datatable.component.ts